module.exports = __webpack_public_path__ + "img/white-card-display.f6f49191.png";